'use-strict';



var titleSameHeight = {
    selector: '.js-title-sameheight',

    init: function() {
        this.$elements = $(this.selector);
        this.$parents = null;

        this.removeStyles();
        this.setParents();
    },

    setParents: function() {
        this.$elements.each((index, item) => {
            const $parent = $(item).parent();

            if (this.$parents === null) {
                this.$parents = $parent;
            }

            else if (!this.$parents.index($parent)) {
                this.$parents = this.$parents.add($parent);
            }

            if (index + 1 === this.$elements.length) {
                this.checkElements();
            }
        });
    },

    removeStyles: function() {
        $('.js-title-headline').css('height', 'auto');
        $('.js-title-text').css('padding-top', 0);
    },

    checkElements: function() {
        this.$parents.each(function(index, item) {
            const $item = $(item);
            let $childs = $('.js-title-sameheight', item);
            const $firstChild = $childs.eq(0);
            const cols = parseInt($firstChild.attr('data-cols'));
            const media = $firstChild.attr('data-media');

            if (!media || window.matchMedia(media).matches) {
                $childs = $childs.filter(function( index ) {return index % cols === 0;});

                $childs.each(function(index, item) {
                    var $item = $(item);
                    var $title = $('.js-title-headline', item);
                    var $siblings = $(item).siblings().filter(function( index ) {return index < cols});
                    var maxHeight = $title.height();
                    var maxOuterHeight = $title.outerHeight();
                    
                    $siblings.each(function(index, item) {
                        var $item = $(item);
                        var $title = $('.js-title-headline', item);
                        var height = $title.height();
                        var outerHeight = $title.outerHeight();

                        if (height > maxHeight) {
                            maxHeight = height;
                            maxOuterHeight = outerHeight;
                        }
                    });

                    if (maxHeight > $title.height()) {
                        var $els = $item.add($siblings);

                        $els.each(function(index, item) {
                            const $headline = $('.js-title-headline', item);
                            const $text = $('.js-title-text', item);

                            $headline.css('height', maxOuterHeight);
                            $text.css('padding-top', (maxHeight - $text.height()) / 2);
                        });
                    }
                });
            }
        });
    }
};



$(function() {

    var resizeEvent = function() {
        titleSameHeight.removeStyles();
        titleSameHeight.checkElements();
    }

    if (window.matchMedia) {
        window.setTimeout(function() {
            titleSameHeight.init();
        }, 500);

        $(window).on('resize', resizeEvent);
    }

});